import React , { Component } from 'react';
import { hot } from 'react-hot-loader/root';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import FormView from "./modules/commonViews/FormView";


class App extends Component {
    render() {
        return (
            <Router>
                <div>
                    <Switch>
                        <Route path="/user/register">
                            <FormView path={"user/register"} />
                        </Route>
                        <Route path="/user/recover">
                            <FormView path={"user/recover"} />
                        </Route>
                        <Route path="/user/activate">
                            <FormView path={"user/activate"} />
                        </Route>
                        <Route path="/">
                            <FormView path={"home"} />
                        </Route>
                    </Switch>
                </div>
            </Router>
        )
    }
}
export default hot(App);
